export const reSetMapAndListView = (toggleView: string | undefined,enableMapViewHideOption: boolean,displayListViewFirst: boolean): boolean => {
  if (toggleView === 'list') {
    return true;
  }
  if (toggleView === 'map') {
      return false;
  }
  // If toggleView is not set, use the feature flag and displayListViewFirst to
  // determine the initial state of the list view.
    return enableMapViewHideOption && displayListViewFirst;
  };